module.exports = __webpack_public_path__ + "img/客车.e6e1109b.png";